// extracted by mini-css-extract-plugin
module.exports = {"headerNobody":"HeaderNobody_headerNobody__2HJxM","headerNobodyContent":"HeaderNobody_headerNobodyContent__3Bjjc"};